// extracted by mini-css-extract-plugin
export default {"landingLayout":"LandingLayout_landingLayout__d-ZGE","landingLayout__app":"LandingLayout_landingLayout__app__temD1"};